import { Component, Input } from '@angular/core';

@Component({
    selector: 'atx-jumbo-tron',
    template: `<div class="jumbotron {{ clazz }}"
              [class.jumbotron-fluid]="isFluid">
    <ng-content></ng-content>
</div>
`,
    styles: [``],
})

export class AtxJumboTronComponent {
    @Input() public readonly clazz: string;
    @Input() public readonly isFluid: boolean;
}
